import { createTheme } from "@mui/material";

export const theme = createTheme({
  root: {
    margin: "inherit"
  },
  components: {
    // Name of the component
    MuiTypography: {
      styleOverrides: {
        root: {
          margin: "0px"
        }
      }
    }
  },
  typography: {
    margin: 0,
    head: {
      fontSize: "100px",
    },
    head1: {
      fontSize: "64px",
    },
    head2: {
      fontSize: "36px",
    },
    head3: {
      fontSize: "28px",
    },
    head4: {
      fontSize: "24px",
    },
    head5: {
      fontSize: "20px",
    },
    body1: {
      fontSize: "18px",
    },
    body2: {
      fontSize: "16px",
    },
    body3: {
      fontSize: "14px",
    },
    body4: {
      fontSize: "12px",
    },
    body5: {
      fontSize: "11px",
    },
    body6: {
      fontSize: "10px",
    },
    body7: {
      fontSize: "7px",
    },
    textLarge: {
      fontSize: "48px",
    }
  },
});
